/**
 * Loading Spinner Component
 * コード分割時のSuspense fallbackとして使用
 */

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const glow = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px rgba(135, 206, 235, 0.4);
  }
  50% {
    box-shadow: 0 0 30px rgba(135, 206, 235, 0.8);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: ${theme.spacing.xl};
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid rgba(135, 206, 235, 0.2);
  border-top: 3px solid ${theme.colors.primary.cobalt};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite, ${glow} 2s ease-in-out infinite;
`;

const LoadingText = styled.p`
  margin-top: ${theme.spacing.lg};
  color: ${theme.colors.text.accent};
  font-size: ${theme.fonts.sizes.base};
  font-weight: ${theme.fonts.weights.medium};
  text-align: center;
  opacity: 0.8;
`;

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = '読み込み中...' 
}) => {
  return (
    <LoadingContainer role="status" aria-live="polite" aria-label={message}>
      <Spinner />
      <LoadingText>{message}</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingSpinner;